import { render } from "./AdDocViewPodiums.vue?vue&type=template&id=7229fff6&scoped=true&ts=true"
import script from "./AdDocViewPodiums.vue?vue&type=script&lang=ts"
export * from "./AdDocViewPodiums.vue?vue&type=script&lang=ts"

import "./AdDocViewPodiums.vue?vue&type=style&index=0&id=7229fff6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7229fff6"]])

export default __exports__